import { mapState } from 'vuex'

export default {
  name: 'HomeCards',
  computed: {
    ...mapState(['config']),
    cards () {
      const roles = this.$session.get('roles');
      const cards = [];
      const filters = {
        clientName: '',
        reportStatuses: ['FILLED', 'FIXED_REW'],
        reportMaterialGroups: [],
        formDatePeriod: this.config.lastCompletedDatePeriod,
        toDatePeriod: null,
        clientManager: [],
        clientClassificationGroups: [],
        clientStatuses: []
      };
      if (this.ApiRequest.userHasPermission('view-clients')) {
        cards.push({ routename: 'menu.reports.simple', title: this.$t('home.cards.newestReports'), filters: this.BasicHelper.cloneObject(filters) });
      }
      if (roles.includes('manager') || roles.includes('admin')) {
        filters.clientOnlyMine = 1;
        cards.push({ routename: 'menu.reports.simple', title: this.$t('home.cards.myClientNewestReports'), filters: this.BasicHelper.cloneObject(filters) });
      }
      return cards;
    }
  },
  methods: {
    openItem (card) {
      if (card.filters) {
        this.BasicHelper.updateFilterValues(card.routename, card.filters);
      }
      this.$router.push({ name: card.routename });
    }
  }
}
